export default __webpack_public_path__ + "static/B0115-1e57d3323b2b7eb0e67ef8d8db7a47bb.png";